import { createFileRoute } from '@tanstack/react-router';
import { PersonalListPage } from '@/features/my-tasks/pages';

export const Route = createFileRoute('/w/$workspaceId/my/personal')({ component: PersonalListPage });
